import { SurgeryRequestData } from '../pages/hospital/Request/RequestForm';

/**
 * Format CIM-11 / ICD-11 code for surgery waiting-list display (SHER-462).
 * Returns "-" when no diagnosis is present so the table never shows a blank cell.
 */
export function formatSurgeryCim11(typeSpecificData?: SurgeryRequestData | null): string {
    if (!typeSpecificData) {
        return '-';
    }
    const code = typeSpecificData['ict-code'] ?? typeSpecificData.ictCode ?? '';
    const label = typeSpecificData.ict ?? '';
    if (code && label) {
        return `${code} — ${label}`;
    }
    return String(code || label || '') || '-';
}
